
import ArrayMixins from '@/mixins/ArrayMixins'
import SiteMixins from '@/mixins/SiteMixins'


export default {
  mixins: [ArrayMixins, SiteMixins],

  computed: {
    isBackhaul: function () {
      return this.actionData.actionType === 'RTB'
    },

    isPending: function () {
      return this.step.approvedStatus === 'Pending'
    },

    isRejected: function () {
      return this.step.approvedStatus === 'Rejected'
    },

    approvalButton: function () {
      let type = 'info'

      if (this.step.approvedStatus === 'Approved') {
        type = 'success'
      }

      if (this.step.approvedStatus === 'Conditional') {
        type = 'warning'
      }

      if (this.step.approvedStatus === 'Rejected') {
        type = 'danger'
      }

      return type
    }
  },

  methods: {

    isActive (data) {

      if (data) {
        return !(data.status === 'Closed' || data.status === 'Rejected')

      } else {
        return false
      }

    },



    requestTableRef (type) {
      return type.toLowerCase() + '-action-table'
    },



    /**
    * Get file URL given site_id, step, etc.
    */
    url (siteId, id, step = null, title = null, caption = null, uploadBy = null) {

      var u = this.getEndpoint('/file/upload/site/' + siteId + '/rts/' + id)

      if (step) {
        u += '/' + step
      }

      if (title) {
        u += '/' + title
      }

      if (title && step) {   // Provides caption for upload.
        u += '/' + title + ' for  step ' + step
      } else {
        if (step) {
          u += '/Request Step ' + step + ' doc'
        } else {
          u += '/' + (title ? title : (step ? 'Request Step ' + step + ' Doc' : null))
        }
      }

      if ((step || title) && this.getStore().loggedName) {
        u += '/' + this.getStore().loggedName
      }

      return u
    },



    updateEmailList (list, contacts, addMissing = false) {

      if (list && contacts) {

        var empty = (list.length === 0)

        for (var c in contacts) {
          var add = empty
          var cont = {}

          cont.name = contacts[c].name
          cont.email = contacts[c].email
          cont.sendUploadAlerts = contacts[c].sendUploadAlerts
          cont.sendApprovalAlerts = contacts[c].sendApprovalAlerts

          if (cont.email &&
            (cont.sendUploadAlerts || cont.sendApprovalAlerts)) {

            if (!empty && addMissing) {
              add = !this.exists('email', cont.email, list)
            }

            if (add) {
              list.push(cont)
            }
          } // if

        } // outer for
      }

    },


    approvalAlert (data, status, date, remarks = null, telcoId = null, info1 = null, info2 = null, info3 = null) {
      var sendMail = true

      if (data) {

        data.info.approval = status
        data.info.telcoSiteId = telcoId
        data.info.date = date
        data.info.info1 = info1
        data.info.info2 = info2
        data.info.info3 = info3
        data.info.remarks = remarks
        data.info.link = null

        sendMail = data.info.sendMail

        if (sendMail) {
          this.send(this, this.getEndpoint('mail/approval-alert'), data, status + ' Notice e-Mail', this.approvalSent)
        } else {
          this.$message({message: 'E-mails are turned off. No e-mail sent.', type: 'info'})
        }

      }
    },



    afterUpload (response, extraData = null) {
      var data = extraData
      var sendMail = true

      if (extraData) {
        data.info = extraData.info
        data.info.file = response.name

        sendMail = data.info.sendMail
        data.info.link = this.getEndpoint('file/download/' + response.url)
      }

      if (sendMail) {
        this.send(this, this.getEndpoint('mail/upload-alert'), data, 'Upload Notice e-Mail', this.uploadSent)
      } else {
        this.$message({message: 'E-mails are turned off. No e-mail sent.', type: 'info'})
      }

    },


    // XOL-526 (UX U-F): built from A7's { notifiedOrgs, skippedOrgs,
    // failedOrgs } rather than a fixed "sent" string, and 'primary' (not a
    // valid $message type) is gone. `skippedOrgs` is optional (X6) — its
    // absence is read as "no gap to report", which degrades to the plain
    // "all notified" sentence. `failedOrgs` (parties whose send THREW) only
    // arrives on a 200 — a request where every send failed is a 422 instead,
    // which never reaches this callback (it goes through send()'s own
    // failure path, no extra toast here).
    uploadSent (response) {
      var notified = (response && response.notifiedOrgs) || []
      var skipped = (response && response.skippedOrgs) || []
      var failed = (response && response.failedOrgs) || []

      if (notified.length === 0) {
        // XOL-526 (reviewer correction 2026-09-23): the API returns "no
        // recipients" and "mail off" as HTTP 200 with a `warning` key, not a
        // non-200 status — PostMixins.checkWarning() (`src/main.js`) only
        // fires its own notify when `response.status !== 200`, so it never
        // sees this case and `send()` still calls this successCallback.
        // uploadSent() must surface the warning itself.
        if (response && response.warning) {
          this.$notify({ type: 'warning', title: 'Warning', message: response.warning, duration: 5500 })
        } else {
          this.$message({ message: 'Upload saved. No upload notice was sent.', type: 'info' })
        }
        return
      }

      var message
      var type

      if (skipped.length > 0) {
        var verb = skipped.length === 1 ? 'has' : 'have'
        var was = skipped.length === 1 ? 'was' : 'were'

        message = 'Upload notice e-mailed to ' + this.orgList(notified) + '. ' +
          this.orgList(skipped) + ' ' + verb + ' no upload-notice recipients set up, so ' + was + ' not notified.'
        type = 'warning'
      } else {
        message = 'Upload notice e-mailed to ' + this.orgList(notified) + '.'
        type = 'success'
      }

      if (failed.length > 0) {
        message += ' The notice to ' + this.orgList(failed) + ' could not be sent.'
        type = 'warning'
      }

      this.$message({ message: message, type: type })
    },

    // XOL-526: 'A', 'A and B', or 'A, B and C', in the list's own order
    // (server order: Tower Co, telco, provider). Each entry is
    // { name, shortName } — shortName preferred, name as a fallback.
    orgList (list) {
      var names = []

      for (var i = 0; i < list.length; i++) {
        var o = list[i]
        if (o && (o.shortName || o.name)) names.push(o.shortName || o.name)
      }

      if (names.length === 0) return ''
      if (names.length === 1) return names[0]
      if (names.length === 2) return names[0] + ' and ' + names[1]

      return names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1]
    },

    approvalSent (response) {

      let notice = (this.step.approvedStatus === 'Approved'
      ? 'success'
      : this.step.approvedStatus === 'Conditional' ? 'warning' : 'info')

      this.$message({message: this.step.approvedStatus + ' e-mail sent', type: notice})
    },

    updateAction (value) {
      this.actionData = value
    },



    info (rowData, stepData, stepNo) {

      if (!rowData || !stepData || !stepNo) {
        return null
      }

      stepNo = Number(stepNo)

      var data = {
        info: {},
        sendTo: []
      }

      if (rowData && rowData.state && rowData.emails) {

        // XOL-526: was `isTelco() ? 'tower' : 'telco'`, so a Backhaul provider
        // (isTelco() false) fell into the 'telco' branch and got mailed the
        // TELCO's own list. After API-3, the server recomputes recipients from
        // info.rts_id itself and ignores sendTo — this now only picks a
        // sensible value for the payload it still sends.
        var prop = this.isTowerCo() ? 'telco' : 'tower'

        if (rowData.emails[prop]) {
          for (var i = 0; i < rowData.emails[prop].length; i++) {
            if (rowData.emails[prop][i] && !data.sendTo.includes(rowData.emails[prop][i])) {
              data.sendTo.push(rowData.emails[prop][i])
            }
          }

        }

        data.info.step = stepNo
        data.info.stepName = stepData.stepName
        data.info.sendMail = rowData.emails.sendMail ? rowData.emails.sendMail : false
        data.info.rts_id = rowData.id ? Number(rowData.id) : null
        data.info.actionType = rowData.actionType
        data.info.requestType = (rowData.actionType === 'RTS' ? 'Share' : (rowData.actionType === 'RTU' ? 'Upgrade' : rowData.actionType === 'RTB' ? 'Backhaul' : 'Other'))
        data.info.site_id = rowData.site_id ? Number(rowData.site_id) : null
        data.info.towerCoName = this.xolasClient().name ? this.xolasClient().name : 'Xolas TMS'
        data.info.email = this.xolasClient().email ? this.xolasClient().email : 'support@xolas.io'
        data.info.phone = this.xolasClient().phone ? this.xolasClient().phone : null
        data.info.siteName = rowData.site && rowData.site.siteName ? rowData.site.siteName : 'No Site Selected'
        data.info.siteId = rowData.site && rowData.site.siteId ? rowData.site.siteId : 'N/A'
        data.info.telcoSiteId = rowData.site && rowData.site.telcoSiteId
        ? rowData.site.telcoSiteId
        : (rowData.state && rowData.state.step2 && rowData.state.step2.siteId ? rowData.state.step2.siteId : 'N/A')
        data.info.sharerName = rowData.organisation && rowData.organisation.name ? rowData.organisation.name : 'No Sharer Selected'
      }

//      console.log('info: data', data, 'rowData', rowData)


      return data
    },


    /**
     * Workflow Steps: find, getSibling & workflow
     */
    findWorkflowStep (stepNo, partyNo, wf, replace = false, step = null) {

      stepNo = Number(stepNo)
      partyNo = Number(partyNo)

      if (wf) {
        for (let i = 0; i < wf.length; i++) {
          if (Number(wf[i].partyNo) === partyNo && Number(wf[i].stepNo) === stepNo) {

            if (replace && step) {
              wf[i] = step
//              console.log('replace step', replace, stepNo, partyNo, step, wf[i])
            }

            return wf[i]
          }
        }
      } else {
        this.$message({type: 'error', message: 'Workflow not found!'})
      }

      return null
    },


    workflow (partyNo, workflow) {

      partyNo = Number(partyNo)

      let wf = []

      if (partyNo > 0 && workflow && workflow.length > 0) {
        for (let i = 0; i < workflow.length; i++) {

          if (Number(workflow[i].partyNo) === partyNo) {
            wf.push({title: workflow[i].stepName, icon: workflow[i].stepIcon, colour: workflow[i].stepColour, comp: null, data: null})
          }

        }
      }

      return wf
    },



    getSibling (stepNo, stepId) {

      stepNo = Number(stepNo)
      stepId = Number(stepId)

      let list = this.rowData.steps

      if (list && stepNo && stepId) {
        for (let i = 0; i < list.length; i++) {
          if (Number(list[i].stepNo) === stepNo && Number(list[i].id) !== stepId) {
            return list[i]
          }
        }
      }
    },


    /**
     * saveRequest and saveStep
     */
    saveRequest (data, callback = null, stepData = null, failCallback = null, notifyFailureCallback = false) {

      if ((!data || !(typeof data === 'object'))) {
        return false
      }

      if (data.targetDate) {
        data.targetDate = this.formatDateSql(data.targetDate)
      }

      if (data.actualDate) {
        data.actualDate = this.formatDateSql(data.actualDate)
      }

      if (data.approved_at) {
        data.approved_at = this.formatDateSql(data.approved_at)
      }

      if (data.completed_at) {
        data.completed_at = this.formatDateSql(data.completed_at)
      }

      this.saveForm(this, '/actions', data.id, data,
        'Save ' + data.actionType + (data.status ? ' ' + data.status : ''),
        callback, failCallback || this.failedRequest, false, null, notifyFailureCallback)


      if (stepData) {
        this.saveStep(stepData)
      }

      return true
    },



    stepSaved (data) {
      if (this.actionData && data) {
        this.replaceStepData(data, this.actionData)
      }
    },



    // XOL-526: null-safe org-id match. Guards against an unhydrated org()
    // (Number(undefined) → NaN → false, never a false-positive match) and
    // against string/number id mismatches from mixed API/JSON sources.
    requestOrgMatches (orgId) {
      var me = this.org()
      if (orgId === null || orgId === undefined || !me || me.id === null || me.id === undefined) return false
      return Number(orgId) === Number(me.id)
    },

    // XOL-526: is the logged-in org the RTx's organisation_id (owner)? Never
    // true for a Tower Co viewer — the Tower Co is party 1, not a counterparty.
    isRequestOwner () {
      var a = this.actionData || this.rowData
      return !this.isTowerCo() && !!a && this.requestOrgMatches(a.organisation_id)
    },

    // XOL-526: is the logged-in org the RTB's provider_id?
    isRequestProvider () {
      var a = this.actionData || this.rowData
      return !this.isTowerCo() && !!a && this.requestOrgMatches(a.provider_id)
    },

    // XOL-526: the provider, and NOT also the owner (an org can be both when it
    // is its own provider — treat that org as the owner, per plan §7).
    isProviderOnlyViewer () {
      return this.isRequestProvider() && !this.isRequestOwner()
    },

    // XOL-526: mirrors the API's tenant.towerco cross-tenant read rule — the
    // caller may read org-scoped data when it IS the Tower Co, or when the
    // data belongs to the caller's own org.
    canReadOrgScoped (orgId) {
      return this.isTowerCo() || this.requestOrgMatches(orgId)
    },

    // XOL-526: which party row (1 or 2) the CURRENT viewer's writes/reads
    // belong to. Tower Co is always party 1; every counterparty is party 2,
    // except a single-party workflow (parties < 2), where only pane 1 exists.
    viewerPartyNo () {
      var a = this.actionData || this.rowData
      return (this.isTowerCo() || !a || Number(a.parties) < 2) ? 1 : 2
    },

    // XOL-526: moved verbatim from RequestWorkflow.partyStepCompleted
    // (XOL-107/XOL-344) so step1-5 and other request surfaces can gate on it
    // too. Party-1 is authoritative (a manager's "Complete Step" toggle) and
    // reads actionData.steps (the full both-parties array). Missing party-1
    // row → false (default allow, matches the API's own default).
    partyOneStepCompleted (stepNo) {
      var a = this.actionData || this.rowData
      var steps = a && a.steps
      if (!steps) return false
      for (var i = 0; i < steps.length; i++) {
        var s = steps[i]
        if (Number(s.stepNo) === Number(stepNo) && Number(s.partyNo) === 1) {
          return !!s.completed
        }
      }
      return false
    },

    // XOL-526: does a distinct backhaul provider exist on this RTB (i.e. is
    // provider_id set AND different from organisation_id)? Drives the shared
    // party-2 tab suffix, cue line and the EmailSetup provider line.
    hasDistinctProvider () {
      var a = this.actionData || this.rowData
      return !!(a && a.actionType === 'RTB' && a.provider_id &&
        Number(a.provider_id) !== Number(a.organisation_id))
    },

    // XOL-526: the provider's short name (A12's providerShortName, else the
    // viewer's own short name when the viewer IS the provider), or null when
    // neither resolves.
    providerShort () {
      var a = this.actionData || this.rowData
      if (a && a.providerShortName) return a.providerShortName
      if (this.isRequestProvider()) {
        var me = this.org()
        if (me && me.shortName) return me.shortName
      }
      return null
    },

    // XOL-526: providerShort(), with the UX spec's generic fallback.
    providerLabel () {
      var short = this.providerShort()
      return short || 'the backhaul provider for this request'
    },

    // XOL-526 (UX §2.4, §1.7): providerLabel(), capitalised for sentence-
    // initial use. A resolved short name is already properly cased, so this
    // is a no-op for it; it only matters for the generic fallback.
    providerLabelCapitalized () {
      var s = this.providerLabel()
      return s.charAt(0).toUpperCase() + s.slice(1)
    },

    // XOL-526 (UX §1.7(a)): the party-2 tab label, suffixed with the
    // provider's short name on an RTB where the provider is distinct from
    // the telco — "{TELCO} & {PROVIDER}" for every viewer. Party 1's label
    // is untouched. Moved here from RequestWorkflow/CompletedRequest, which
    // each had an identical copy, so it can be shared by every caller of
    // `partyName()` (a per-component method, still resolved on `this`).
    partyTabLabel (partyNo) {
      var base = this.partyName(partyNo)

      if (Number(partyNo) !== 2 || !this.hasDistinctProvider()) {
        return base
      }

      var short = this.providerShort()
      return short ? base + ' & ' + short : base
    },

    // XOL-526 (UX §1.7(b)): the Telco/Tower Co's lighter equivalent of the
    // provider banner, shown under the shared party-2 file list. Moved here
    // from RequestWorkflow/CompletedRequest, which each had an identical copy.
    sharedFilesCue () {
      var label = this.providerLabel()

      if (this.isRequestOwner()) {
        return 'Files on this tab are shared with ' + label + '. Both organisations can see and download every file here; each file shows who uploaded it.'
      }

      if (this.isRequestProvider()) {
        return 'Files on this tab are shared with ' + this.actionData.organisation.name + '. Both organisations can see and download every file here; each file shows who uploaded it.'
      }

      return 'Files on this tab are uploaded by ' + this.actionData.organisation.name + ' and ' + label + '. Each file shows who uploaded it.'
    },

    // XOL-526 (D12): a null-safe read of a `state.edits.<field>` stamp —
    // `{ by, org, at }`, set server-side (A9/A10) the first time a
    // counterparty changes a shared field. Returns null before that.
    editStamp (state, field) {
      return (state && state.edits && state.edits[field]) ? state.edits[field] : null
    },

    // XOL-526 (UX §2.4, U-I): "Last updated by {who} ({org}) on {when}" from
    // a D12 stamp, or '' when the field has never been counterparty-edited
    // (never call formatDateTime on a null stamp).
    lastUpdatedLine (stamp) {
      if (!stamp || !stamp.by) return ''
      return 'Last updated by ' + stamp.by + (stamp.org ? ' (' + stamp.org + ')' : '') + ' on ' + this.formatDateTime(stamp.at)
    },

    // XOL-526 (UX §2.4, U-I): the "someone else can also …" note shown above
    // a shared editor, while it is actually editable for this viewer. `action`
    // is the field-specific verb phrase, e.g. 'edit these remarks' or
    // 'change the Technical Proposal type'. The owner sees the provider named
    // (capitalised — it may open the sentence); the provider sees the
    // telco's real org name.
    // XOL-534 round 3: the UX spec (§2.4) says this note shows only when the
    // field is editable for THIS viewer under isCounterpartyWriter() — i.e.
    // never for the Tower Co. That guard is centralised HERE, not left to
    // each caller, after step2's tpTypeNote proved a caller can omit it:
    // `counterpartyTpLocked` is false for a writable Tower Co too (its
    // canWriteOwnStep() is canWriteStep()), so a per-caller "is this field
    // unlocked" check alone doesn't distinguish "unlocked for a Tower Co"
    // from "unlocked for a counterparty". hasDistinctProvider() is
    // centralised too — the note text always names a specific counterparty,
    // so it's meaningless without one, and every caller already needed it.
    sharedFieldNote (action) {
      if (!this.isCounterpartyWriter() || !this.hasDistinctProvider()) return null

      var a = this.actionData || this.rowData
      var who = this.isRequestOwner()
        ? this.providerLabelCapitalized()
        : ((a && a.organisation && a.organisation.name) ? a.organisation.name : 'The other organisation')
      return who + ' can also ' + action + '. The last saved version is kept.'
    },

    // XOL-526 (D9): a non-Tower-Co, non-view-only caller who is either the
    // owner or the provider of an ACTIVE RTB. RTB-only, mirrors API A9/A10
    // (RequestPartyResolver::canWriteContent, xolas-tms-api xol-531 @
    // 1c835715). Flipped on in SPA-2 (XOL-534) now API-4/5 are live.
    isCounterpartyWriter () {
      var a = this.actionData || this.rowData
      return !this.isTowerCo() && !this.isViewOnly() && !!a && a.actionType === 'RTB' &&
        this.isActive(a) && (this.isRequestOwner() || this.isRequestProvider())
    },

    // XOL-526: request-level (PUT /actions) write gate — Tower Co keeps its
    // existing canWriteStep() rule; a counterparty needs isCounterpartyWriter().
    canWriteOwnRequest () {
      return this.isTowerCo() ? this.canWriteStep() : this.isCounterpartyWriter()
    },

    // XOL-526: step-level (PUT /step) write gate for a SPECIFIC step row.
    // A counterparty may only write its own party-2 row, and only while the
    // matching party-1 row isn't completed (mirrors API A10).
    canWriteOwnStep (step) {
      if (this.isTowerCo()) return this.canWriteStep()
      return this.isCounterpartyWriter() && !!step && Number(step.partyNo) === 2 &&
        !this.partyOneStepCompleted(step.stepNo)
    },

    // XOL-526: emails.telco lists the telco's OWN people — only the owner (or
    // Tower Co) may edit it, never the provider.
    canEditTelcoRecipients () {
      return this.isTowerCo() ? this.canWriteStep() : (this.isCounterpartyWriter() && this.isRequestOwner())
    },

    // XOL-526: minimal PUT /actions for a counterparty write. The API (A9)
    // merges these into the stored record — never resend the whole actionData,
    // which would race a Tower Co save and wipe its fields (D7 protects the
    // reverse direction server-side, but there's no reason to invite it).
    saveOwnRequestFields (fields, callback) {
      var a = this.actionData || this.rowData
      var p = { id: a.id, site_id: a.site_id, actionType: a.actionType, organisation_id: a.organisation_id }
      for (var k in fields) { if (Object.prototype.hasOwnProperty.call(fields, k)) p[k] = fields[k] }
      return this.saveRequest(p, callback, null, this.failedOwnSave)
    },

    // XOL-526: minimal PUT /step for a counterparty write. The API (A10)
    // merges `state` — never resend the whole step object.
    saveOwnStep (step, fields) {
      var p = {
        id: step.id,
        action_id: step.action_id,
        organisation_id: step.organisation_id,
        stepNo: step.stepNo,
        partyNo: step.partyNo,
        stepName: step.stepName
      }
      for (var k in fields) { if (Object.prototype.hasOwnProperty.call(fields, k)) p[k] = fields[k] }
      this.saveForm(this, '/step', step.id, p, step.stepName, this.stepSaved, this.failedOwnSave, false)
    },

    // XOL-526: saveForm() already raises a $notify for the failure — this
    // exists only so a counterparty save doesn't fall through to
    // failedRequest/failedStep, whose site_id/organisation_id = null side
    // effects assume the Tower Co owns the record. Never null anything.
    failedOwnSave (response) {
      console.error('own save failed', response)
    },

    // XOL-348: return the organisation_id of the party-1 step (the owning
    // TowerCo step). Returns null when steps are unavailable — null → no write,
    // which is the safe direction.
    requestOwnerOrgId () {
      var data = (this.actionData || this.rowData)
      var steps = data && data.steps
      if (!steps) return null
      for (var i = 0; i < steps.length; i++) {
        var s = steps[i]
        if (Number(s.partyNo) === 1) {
          return s.organisation_id != null ? s.organisation_id : null
        }
      }
      return null
    },

    // XOL-348: true only when the logged-in client owns the request.
    // Null-guards xolasClient() so an unhydrated client never throws
    // (Number(undefined) → NaN → false).
    ownsRequest () {
      var ownerId = this.requestOwnerOrgId()
      if (ownerId === null) return false
      var client = this.xolasClient()
      return Number(ownerId) === Number(client && client.id)
    },

    canWriteStep () {
      // XOL-371 review 2026-07-21: any non-view-only Tower Co user may write
      // steps; the XOL-348/362 manager/approver/ownership gating is dropped
      // (server enforces role:towerco + viewonly.gate).
      return this.isTowerCo() && !this.isViewOnly()
    },

    findStep (id, callback) {
      this.fetchData('step/' + id, callback, 'Request Step')
    },



    saveStep (data, callback = null, action = null, saveAction = false) {

      if (!data || !(typeof data === 'object') || data.length === 0) {
//        console.error('ERROR: saveStep incorrect data type: ', data, typeof data)
        return false
      }

      if (data.approved_at) {
        data.approved_at = this.formatDateTimeSql(data.approved_at)
      }

      if (data.completed_at) {
        data.completed_at = this.formatDateTimeSql(data.completed_at)
      }

      if (action && action.steps) {
        this.replaceStepData(data, action.steps)
      }

      this.saveForm(this, '/step', data.id, data,
        data.stepName,
        this.stepSaved, this.failedStep, false)


      if (saveAction && action) {
        this.saveRequest(action)
      }

      return true
    },


    replaceStepData (step, action) {

      if (!step || !action) {
        return
      }

      if (step.stepNo && step.partyNo && action.steps) {
        this.findWorkflowStep(step.stepNo, step.partyNo, action.steps, true, step)
      }
    },



    failedRequest (response) {
      this.actionData.site_id = null
      this.actionData.organisation_id = null

      this.$message({
        title: 'Unable to save Request',
        message: '[' + response + '] create failed',
        type: 'warning'
      })
    },



    failedStep (response) {
      this.$message({
        title: 'Unable to save Request Step',
        message: '[' + response + '] create failed',
        type: 'warning'
      })
    },


    fixExistingEquipment () {
      if (this.actionData.state.step2.equipment) {

        for (var n = 0; n < this.actionData.state.step2.equipment.length; n++) {
          let item = this.actionData.state.step2.equipment[n]

          if (this.isArray(item.type)) {
            item.category = null
            item.subType = null
            item.variant = null

            for (var i = 0; i < item.type.length; i++) {

              if (item.type[i] && i === 0) {
                item.category = item.type[i]
              }

              if (item.type[i] && i === 2) {
                item.subType = item.type[i]
              }

              if (item.type[i] && i === 3) {
                item.variant = item.type[i]
              }
            } // for

            this.actionData.state.step2.equipment[n].category = item.category
            this.actionData.state.step2.equipment[n].type = item.type[1] // else the for loop gets messed up.
            this.actionData.state.step2.equipment[n].subType = item.subType
            this.actionData.state.step2.equipment[n].variant = item.variant
          }

          if (!item.name) {
            this.actionData.state.step2.equipment[n].name = (item.category ? item.category : '')
            this.actionData.state.step2.equipment[n].name += (item.category ? ' / ' + item.type : item.type)
            this.actionData.state.step2.equipment[n].name += (item.subType ? ' / ' + item.subType : '')
            this.actionData.state.step2.equipment[n].name += (item.variant ? ' / ' + item.variant : '')
          }

        }
      }
    }


  },

  watch: {
    stepData: function (step) {
      this.step = step
//      console.log('stepData changed', this.step)
    },

    step: function (step) {
//      console.log('step changed', this.step)
      this.$emit('updated', step)
    }

  }


}
